/*
  ============================================================
  Clarity — tags de sessão · Todanua
  Serve para as DUAS lojas (nacional e exterior): o snippet se
  identifica sozinho pelo domínio.

  O contexto da página (loja, template, carrinho, produto) vem do
  Liquid por window.TODANUA_CTX, definido inline no <head> do
  theme.liquid. Este arquivo é carregado com defer — nada aqui
  precisa rodar antes da primeira pintura.

  O que ele marca em cada sessão:
    origem / midia / campanha / criativo  -> filtrar gravações por campanha
    pagina / produto / preco_faixa        -> onde a pessoa estava
    etapa                                 -> viu_produto | add_carrinho | foi_checkout
    ref                                   -> id anônimo p/ correlação
  E dispara eventos (add_carrinho, foi_checkout) com "upgrade",
  garantindo que essas sessões sejam gravadas mesmo com amostragem.
  ============================================================
*/
(function () {
  'use strict';

  /* Propaga o id de correlação para o checkout Yampi (?cl_ref=...), para
     ligar a sessão da loja com a sessão do checkout. Deixe false se
     preferir não tocar na URL do checkout. Só afeta a loja BR. */
  var PROPAGAR_REF_YAMPI = false;

  var MAX = 255;

  /* O Clarity pode estar instalado no tema, num app da Shopify, no GTM ou
     num pixel personalizado — e nesses três últimos casos ele carrega
     DEPOIS deste script. Criamos aqui a mesma fila que o snippet oficial
     usa: as chamadas ficam em clarity.q e são processadas quando o script
     de verdade carregar. Assim a ordem de carregamento não importa.
     (Se o Clarity já existir, esta linha não altera nada.) */
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  function api() {
    try {
      if (window.clarity) window.clarity.apply(null, [].slice.call(arguments));
    } catch (e) {}
  }
  function tag(k, v) {
    if (v === null || v === undefined || v === '') return;
    api('set', k, String(v).slice(0, MAX));
  }
  function intencao(nome) {
    tag('etapa', nome);
    api('event', nome);
    api('upgrade', nome); // força a gravação das sessões que importam
  }
  function ls(store, key, value) {
    // sessionStorage pode lançar em modo privado — nunca deixar quebrar a página
    try {
      if (value === undefined) return store.getItem(key);
      store.setItem(key, value);
    } catch (e) {}
    return null;
  }
  function faixa(p) {
    p = Number(p) || 0;
    if (!p) return null;
    if (p < 150) return 'ate_150';
    if (p < 300) return '150_300';
    if (p < 500) return '300_500';
    if (p < 1000) return '500_1000';
    return 'acima_1000';
  }

  var params = new URLSearchParams(location.search);

  /* ---------- 1. Atribuição (UTM só existe na URL de entrada) ---------- */
  var ATTR_KEY = 'todanua_attr';
  var attr = {};
  try {
    attr = JSON.parse(ls(sessionStorage, ATTR_KEY) || '{}');
  } catch (e) {
    attr = {};
  }

  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
    var v = params.get(k);
    if (v) attr[k] = v;
  });
  if (!attr.utm_source) {
    // clique pago sem UTM ainda é identificável pelo id do clique
    if (params.get('fbclid')) attr.utm_source = 'facebook';
    else if (params.get('gclid')) attr.utm_source = 'google';
  }
  if (!attr.origem_primeira) {
    var ref0 = document.referrer || '';
    attr.origem_primeira = ref0 ? ref0.split('/')[2] || 'outro' : 'direto';
  }
  ls(sessionStorage, ATTR_KEY, JSON.stringify(attr));

  tag('origem', attr.utm_source || attr.origem_primeira);
  tag('midia', attr.utm_medium);
  tag('campanha', attr.utm_campaign); // mesmo valor que o dashboard usa p/ casar a campanha
  tag('criativo', attr.utm_content);

  /* ---------- 2. Id anônimo de correlação ---------- */
  var ref = ls(sessionStorage, 'todanua_ref');
  if (!ref) {
    ref = (Date.now().toString(36) + Math.random().toString(36).slice(2, 8)).toUpperCase();
    ls(sessionStorage, 'todanua_ref', ref);
  }
  if (ref) {
    tag('ref', ref);
    api('identify', ref); // id anônimo (sem dado pessoal)
  }

  /* ---------- 3. Contexto da página (vem do Liquid) ---------- */
  var CTX = window.TODANUA_CTX || {};

  tag('loja', CTX.loja);
  tag('pagina', CTX.pagina);
  tag('cliente', CTX.logado ? 'logado' : 'visitante');
  if (CTX.itens_carrinho > 0) tag('carrinho_itens', CTX.itens_carrinho);

  if (CTX.produto) {
    tag('produto', CTX.produto);
    tag('preco_faixa', faixa(CTX.preco));
    tag('etapa', 'viu_produto');
  }

  /* ---------- 4. Adição ao carrinho ----------
     Dois caminhos, sem envolver window.fetch nem XMLHttpRequest (o
     carrinho e o checkout Yampi não podem ser interceptados):
       a) submit em captura — pega o form POST /cart/add de qualquer
          origem (PDP, quick-add, formulário injetado depois);
       b) evento 'cart:update' do tema, disparado por CartAddEvent com
          source 'product-form-component' — cobre as adições por fetch. */
  document.addEventListener(
    'submit',
    function (ev) {
      try {
        var f = ev.target;
        if (f && f.action && String(f.action).indexOf('/cart/add') !== -1) intencao('add_carrinho');
      } catch (e) {}
    },
    true
  );

  document.addEventListener('cart:update', function (ev) {
    try {
      var d = (ev && ev.detail && ev.detail.data) || {};
      // só conta como adição: mudança de quantidade/remoção no carrinho não é intenção nova
      if (d.didError) return;
      if (d.source === 'product-form-component') intencao('add_carrinho');
    } catch (e) {}
  });

  /* ---------- 5. Ida para o checkout ---------- */
  document.addEventListener(
    'click',
    function (ev) {
      try {
        var alvo = ev.target;
        if (!alvo || !alvo.closest) return;
        var el = alvo.closest('a,button,input[type=submit],[name=checkout]');
        if (!el) return;

        var href = (el.getAttribute && el.getAttribute('href')) || '';
        var nome = (el.getAttribute && el.getAttribute('name')) || '';
        var txt = String(el.textContent || el.value || '').toLowerCase();
        var vaiCheckout =
          nome === 'checkout' ||
          href.indexOf('/checkout') !== -1 ||
          href.indexOf('yampi') !== -1 ||
          /finaliz|checkout|comprar agora|fechar pedido/.test(txt);
        if (!vaiCheckout) return;

        intencao('foi_checkout');

        if (PROPAGAR_REF_YAMPI && ref && href && href.indexOf('yampi') !== -1 && href.indexOf('cl_ref=') === -1) {
          el.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'cl_ref=' + ref);
        }
      } catch (e) {}
    },
    true
  );
})();
